import React from 'react';

import { TwitterLogo } from '../../icons/TwitterLogo';
import { LinkedInLogo } from '../../icons/LinkedInLogo';
import { InstagramLogo } from '../../icons/InstagramLogo';

import '../../../css/components/about-us/member-card.scss';
export function MemberCard(props) {
  const {
    name,
    position,
    image,
    bio,
    socialMedia
  } = props;

  const socialMediaLogoMap = {
    twitter: <TwitterLogo/>,
    linkedin: <LinkedInLogo/>,
    instagram: <InstagramLogo/>,
  }

  let socialMediaLinks;

  if(socialMedia) {
    socialMediaLinks = socialMedia.map(media => {
      return (
        <a className="social-media-link" href={ media.url } target="_blank" key={ media.name }>
          { socialMediaLogoMap[media.name] }
        </a>
      )
    })
  }
  

  return (
    <div className="MemberCard">
      <div className="image-wrapper">
        <img className="image" src={ image } alt="member-portrait"/>
        <div className="bio">
          <div className="name">
            { name }
          </div>
          <div className="bio-bottom-half">
            <div className="text">
              { bio }
            </div>
            <div className="social-media">
              { socialMediaLinks }
            </div>
          </div>
          
        </div>
      </div>
      
      <div className="name-position">
        {/* <div className="name">
          { name }
        </div> */}
        <div className="position">
          { position }
        </div>
      </div>
    </div>
  )
}